import * as utils from '../utils.js';
import ShowReel from './showreel.js';

class Header {

  constructor(el) {

    //console.log('initHeader');

	  this.DOM = {};
	  this.DOM.el = el;
	  this.DOM.body = document.body;
	  this.DOM.brand = this.DOM.el.querySelector('.brand');
    this.DOM.toggleMenu = this.DOM.el.querySelector('.toggle__menu');
    this.DOM.menuContainer = this.DOM.el.querySelector('nav');
    this.DOM.showreelCover = this.DOM.el.querySelector('.video--cover');
    this.DOM.fade = document.querySelector('body > .fade');
    this.menuOpen = false;

	  this.init();

  }

  init() {

    //Showreel
    const showreelHome = new ShowReel(this.DOM.el.querySelector('.video--preview'));
    this.DOM.showreelCover.pause();

  	//toggle
  	this.DOM.toggleMenu.addEventListener('click',(e) => {

  		e.preventDefault();
  		this.DOM.body.classList.toggle('showMenu');
  		this.DOM.el.classList.toggle('is-active');

      //if Openning
  		if ( !this.menuOpen ) {

        this.menuOpen = true;
        this.DOM.body.style.overflow = "hidden";
        this.DOM.el.querySelector('.menu__container > .container').scrollTo(0, 0);
        if(window.innerWidth > 767) this.DOM.showreelCover.play();
        document.querySelector('body').classList.add('overflow');

  		} else {

        this.menuOpen = false;
        this.DOM.body.style.overflow = "";
        if (!document.querySelector('.page--home') || window.innerWidth < 767) document.querySelector('body').classList.remove('overflow');

        setTimeout(()=> {
          this.DOM.showreelCover.pause();
        }, 1000);

  		}

  	});

    // Links Click
    const links = this.DOM.menuContainer.querySelectorAll('.nav__link')
    links.forEach((elem) => {

      elem.addEventListener('click',(e)=> {
        if ( this.DOM.menuContainer.querySelector('.active') != null ) {
           this.DOM.menuContainer.querySelector('.active').classList.remove('active');
        }
        e.currentTarget.classList.add('active');
      });

    });

    // Brand Click
    this.DOM.brand.addEventListener('click',(e)=> {

      if ( this.DOM.menuContainer.querySelector('.active') != null ) {
         this.DOM.menuContainer.querySelector('.active').classList.remove('active');
      }

    })

    //fade
    this.DOM.fade.addEventListener('click', (e) => {
      e.preventDefault();
      if ( this.menuOpen ) {
        this.DOM.toggleMenu.click();
      }
    })

  }

}

export default Header;
